<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>

  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Is it time to eat, or is there no more time to eat</p>
      </b-col>
    </b-row>



    <b-row>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Desktop film, website, essay, installation, performance</p>
        <p>
        <i>Is it time to eat, or is there no more time to eat</i> is an extensive review of the most prominent techno-solutionist creation in terms of food. It manifests itself into a desktop film and an essay, alongside an archive of images, articles, videos and more, which together deconstruct the culture of future food, born in the valley of technological quick-fixes.</p>
        <p>
        The work takes a closer look at the culture around the techno-solutionist ideology, and the role of meal replacements within societies which value the authoritative roles of tech innovators and their potential to impact the way humans live.</p>
        <p>The <a href="https://www.youtube.com/watch?v=S-maUIUAC3I" target="_blank">video</a> was presented alongside an installation, <a href="https://food.alicestrete.me/" target="_blank">website</a>, and a participative performance within the Upsetting Settings graduation show of the Experimental Publishing masters program, at UBIK Rotterdam, July, 2019. Find the project <a href="https://project.xpub.nl/is-it-time-to-eat-or-is-there-no-more-time-to-eat/" target="_blank">here</a> and the thesis <a href="https://project.xpub.nl/is-it-time-to-eat-or-is-there-no-more-time-to-eat/pdf/your-body-will-make-itself-heard.pdf" target="_blank">here</a>.</p>
        <p>The video was also presented as part of the <a href="https://esc.mur.at/de/projekt/cyborg-subjects">Cyborg Subjects</a> exhibition at esc medien kunst labor in Graz, Austria.</p>
      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/timetoeat/examples.gif"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/timetoeat/making_huel.gif"></b-img>
      </b-col>

      <b-col md="4">
      <b-img class="img-fluid" src="media/timetoeat/food_waste.gif"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/timetoeat/unlike_food.gif"></b-img>
      </b-col>
    </b-row>

    <b-row class="content">
      <b-col md="4">
        <b-img class="img-fluid" src="media/timetoeat/review.png"></b-img>
      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/timetoeat/table.png"></b-img>
      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/timetoeat/flyer.png"></b-img>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'TimeCard',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}


</script>
